import { render } from "./BoutiqueVoir.vue?vue&type=template&id=40179aff&scoped=true&bindings={\"shared\":\"options\",\"formInfo\":\"setup\",\"route\":\"setup\",\"router\":\"setup\",\"add\":\"setup\",\"sauver\":\"setup\",\"takePhoto\":\"setup\"}"
import script from "./BoutiqueVoir.vue?vue&type=script&lang=js"
export * from "./BoutiqueVoir.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-40179aff"

export default script